import { Icon, type IconProps } from '@iconify/react';
import { Box, type SxProps, type Theme } from '@mui/material';

type IconifyProps = Omit<IconProps, 'icon'> & {
  icon: string;
  sx?: SxProps<Theme>;
};

export default function Iconify({ icon, sx, width = 22, height = 22, ...other }: IconifyProps) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width, height, ...sx }}>
      <Icon icon={icon} width={width} height={height} {...other} />
    </Box>
  );
}

/** Icônes sidebar alignées sur dashboard-b2b-origin (NavConfig.js) */
export const SIDEBAR_ICONS = {
  dashboard: 'mdi:view-dashboard',
  foundObjects: 'gg:search-found',
  returnedObjects: 'la:hands-helping',
  objectsToSend: 'fa6-solid:truck-fast',
  objectsInTransit: 'akar-icons:shipping-box-v1',
  storage: 'eva:shopping-bag-fill',
  events: 'eva:calendar-fill',
  matches: 'mdi:compare-horizontal',
  linkedAnnouncements: 'mdi:newspaper-variant-outline',
  messages: 'noto-v1:left-speech-bubble',
  settings: 'uil:setting',
  menu: 'eva:menu-2-fill',
} as const;

export function sidebarIcon(name: keyof typeof SIDEBAR_ICONS) {
  return <Iconify icon={SIDEBAR_ICONS[name]} width={22} height={22} />;
}
